"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drepTypeToString = exports.isDRepType = exports.DRepType = void 0;
var DRepType;
(function (DRepType) {
    DRepType[DRepType["KeyHash"] = 0] = "KeyHash";
    DRepType[DRepType["Script"] = 1] = "Script";
    DRepType[DRepType["AlwaysAbstain"] = 2] = "AlwaysAbstain";
    DRepType[DRepType["AlwaysNoConfidence"] = 3] = "AlwaysNoConfidence";
})(DRepType = exports.DRepType || (exports.DRepType = {}));
;
Object.freeze(DRepType);
function isDRepType(stuff) {
    return typeof stuff === "number" && (stuff >= 0 && stuff <= 3 &&
        stuff === Math.round(stuff));
}
exports.isDRepType = isDRepType;
function drepTypeToString(t) {
    switch (t) {
        case DRepType.KeyHash: return "KeyHash";
        case DRepType.Script: return "Script";
        case DRepType.AlwaysAbstain: return "AlwaysAbstain";
        case DRepType.AlwaysNoConfidence: return "AlwaysNoConfidence";
        default: return "";
    }
}
exports.drepTypeToString = drepTypeToString;
